import React from 'react'

const ColorPicker = () => {
  return (
    <div>
      
    </div>
  )
}

export default ColorPicker
